module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn--default dropbtn",
    class: _vm.btnClass,
    attrs: {
      "data-label": _vm.$te(((_vm.infos.label) + ".label")) ? _vm.$t(((_vm.infos.label) + ".label")) : _vm.infos.label,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.openDropdown()
      }
    }
  }, [_c('i', {
    staticClass: "dropbtn",
    class: _vm.infos.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content u-textLeft",
    attrs: {
      "id": _vm.infos.identifier
    }
  }, [_c('ul', _vm._l((_vm.infos.options), function(option) {
    return _c('li', {
      key: option
    }, [(_vm.optionIsObject(option)) ? _c('a', {
      class: {
        'is-active': _vm.currentOption === option.value
      },
      on: {
        "click": function($event) {
          return _vm.changeOption(option.value)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$te(((option.label) + ".label")) ? _vm.$t(((option.label) + ".label")) : option.label) + "\n        ")]) : _c('a', {
      class: {
        'is-active': _vm.currentOption === option
      },
      on: {
        "click": function($event) {
          return _vm.changeOption(option)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$te((option + ".label")) ? _vm.$t((option + ".label")) : option) + "\n        ")])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11361f86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/ButtonDropdown.vue
// module id = 2914
// module chunks = 0